import { BasicQueryStringUtils } from '@ting/app-auth';

import type { LocationLike } from '@ting/app-auth';

export class QueryStringUtils extends BasicQueryStringUtils {
  parse(input: LocationLike) {
    return this.parseQueryString(input.search);
  }
}
